// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import store from './store'
import Vue from 'vue'
import axios from 'axios'
import { equipManage } from '@/utils/constant.js'
Vue.prototype.$equipManage = equipManage()
import { exportExcel } from '@/utils/excel'
Vue.prototype.$exportExcel = exportExcel
// import Mock from './assets/mock'
Vue.prototype.$axios = axios;
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import ol from 'ol'
import VDistpicker from 'v-distpicker'
Vue.component('v-distpicker',VDistpicker)

import htmlToPdf from '@/utils/htmlToPdf'
Vue.use(htmlToPdf)
import App from './App'
import router from './router'
import limitBtn from '@/components/limitBtn/index.js';
Vue.use(limitBtn);
Vue.use(ElementUI);
// Vue.use(ol);
import $ from 'jquery'
Vue.config.productionTip = false
// 显示该角色的权限

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})


// WEBPACK FOOTER //
// ./src/main.js